import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import defaultTexts from '../../../texts/texts'
import paypal_logo from '../../../assets/images/paypal_logo_150.png'
import stripe_logo from '../../../assets/images/stripe_logo_150.png'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'
import CustomTextField from '../../_common/_form_fields/CustomTextField'

const ConfigBillingPaymentMethodsItem = (props) => {
  const { name, display_name, paymentMethods, setPaymentMethods, paymentMethodIds, setPaymentMethodIds } = props
  const theme = useTheme()

  const [paymentChecked, setPaymentChecked] = useState(false)
  const [paymentId, setPaymentId] = useState('')

  const selectionWrapperStyle = {
    background: theme.palette.cultured,
    padding: '20px',
    border: `${theme.palette.lightSilver} 1px solid`,
    borderRadius: '20px',
    margin: '10px 0px',
    cursor: 'pointer',
  }

  const checkboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const payWithTextStyle = {
    color: theme.palette.hanBlue,
    fontSize: '20px',
    fontWeight: '600',
    fontStyle: 'italic',
  }

  const imageStyle = {
    maxWidth: 'auto',
    maxHeight: '44px',
  }

  const formControlStyle = {
    background: theme.palette.aliceBlue,
    color: theme.palette.vodka,
    borderRadius: '5px',
    width: '100%',
  }

  const outlinedInputStyle = {
    '& .MuiInputBase-input::label': {
      color: theme.palette.vodka,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
  }

  const getPaymentIdLabel = () => {
    if (name === 'paypal') {
      return defaultTexts.paypalClientId
    }

    if (name === 'stripe') {
      return defaultTexts.stripeSecretKey
    }

    return ''
  }

  const getPaymentLogo = () => {
    if (name === 'paypal') {
      return paypal_logo
    }

    if (name === 'stripe') {
      return stripe_logo
    }

    return ''
  }

  const getPaymentIdDisabled = () => {
    const _payment = paymentMethods.find(item => item.name === name)
    return _payment ? false : true
  }

  const handleChangePaymentChecked = () => {
    if (!paymentChecked) {
      setPaymentMethods(prev => [...prev, { name, display_name }])
    } else {
      setPaymentMethods(prev => prev.filter(item => item.name !== name))
      delete paymentMethodIds[name]
    }

    setPaymentChecked(prev => !prev)
  }

  const handleChangePaymentId = (e) => {
    const value = e.target.value
    setPaymentId(value)

    if (name === 'paypal') {
      setPaymentMethodIds(prev => {
        return {
          ...prev,
          paypal: {
            keyValue: 'client_id',
            idValue: value,
          }
        }
      })
    }

    if (name === 'stripe') {
      setPaymentMethodIds(prev => {
        return {
          ...prev,
          stripe: {
            keyValue: 'secret_key',
            idValue: value,
          }
        }
      })
    }
  }

  useEffect(() => {
    const _payment = paymentMethods.find(item => item.name === name)
    
    if (_payment) {
      setPaymentChecked(true)

      if (paymentMethodIds && paymentMethodIds[name] && paymentMethodIds[name].idValue) {
        setPaymentId(paymentMethodIds[name].idValue)
      }
    } else {
      setPaymentChecked(false)
      setPaymentId('')
    }
  }, [paymentMethods, paymentMethodIds, name])
  
  return (
    <>
      <Grid
        container
        spacing={{ lg: 6, xl: 12 }}
        sx={{ borderBottom: `${theme.palette.lightSilver} 1px dotted` }}
      >
        <Grid size={{ lg: 5, xl: 4 }}>
          <Box sx={selectionWrapperStyle} onClick={handleChangePaymentChecked}>
            <Stack
              direction='row'
              alignItems='center'
              justifyContent='flex-start'
              spacing={2}
            >
              <CustomCheckboxField
                checked={paymentChecked}
                handleChange={() => {}}
                sx={checkboxStyle}
              />
              <Box sx={payWithTextStyle}>{defaultTexts.payWith}</Box>
              <Box>
                <img src={getPaymentLogo()} alt='' style={imageStyle} />
              </Box>
            </Stack>
          </Box>
        </Grid>
        <Grid size={{ lg: 7, xl: 5 }}>
          <Box sx={{ paddingTop: '30px' }}>
            <CustomTextField 
              variant='outlined'
              label={getPaymentIdLabel()}
              currentValue={paymentId}
              setCurrentValue={handleChangePaymentId}
              required={true}
              disabled={getPaymentIdDisabled()}
              size='small'
              sx={formControlStyle}
              outlinedInputSx={outlinedInputStyle}
            />
          </Box>              
        </Grid>
      </Grid>      
    </>
  )
}

export default ConfigBillingPaymentMethodsItem